import React, { useEffect, useRef } from 'react';
import {
  Image, Text, TouchableOpacity, View,
} from 'react-native';
import { img_check_black } from '../../../utils/ImagesManagementUtils';
import { LocStr } from '../../../utils/Utils';

//= ========================================================================

const OpenBox = ({
  language, chosenValue, valuesMap, onValueChanged, onPress, right = 20, top = 40, openBoxWidth = 170, checkImageLeft,
}) => {
  const myStyles = {
    container: {
      right,
      top,
      position: 'absolute',
      background: 'white',
      padding: 5,
      paddingStart: 12,
      width: openBoxWidth,
      border: 'solid 1px #cbd5e0',
      borderRadius: 4,
    },
    imageStyle: {
      width: 24,
      height: 24,
    },
    textMarginLeft: {
      marginLeft: checkImageLeft && 24,
    },
    touchableStyle: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 5,
      marginBottom: 10,
      padding: 2,
    },
  };
  const menuRef = useRef();
  useEffect(() => {
    const handler = (event) => {
      if (!menuRef.current.contains(event.target)) {
        onPress();
      }
    };
    document.addEventListener('mousedown', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
    };
  });
  return (

    <View style={myStyles.container} ref={menuRef}>
      {Object.keys(valuesMap)
        .map((valueId) => (
          <TouchableOpacity
            key={valueId}
            style={myStyles.touchableStyle}
            onPress={() => {
              onValueChanged(valueId);
              onPress();
            }}
          >
            {!checkImageLeft && <Text style={valueId !== chosenValue && myStyles.textMarginLeft}>{LocStr(valuesMap[valueId], language)}</Text>}
            {valueId === chosenValue && (
              <Image
                style={myStyles.imageStyle}
                fadeDuration={0}
                source={img_check_black}
              />
            )}
            {checkImageLeft && <Text style={valueId !== chosenValue && myStyles.textMarginLeft}>{LocStr(valuesMap[valueId], language)}</Text>}
          </TouchableOpacity>
        ))}
    </View>
  );
};
export default OpenBox;
